<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { _ } from "svelte-i18n";
  import type { NavItem } from "$lib/gql/genCms/codegen";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Link from "$lib/components/Link/Link.svelte";
  import NavPromoImage from "../NavPromoImage/NavPromoImage.svelte";

  export let navItem: NavItem;
  export let twoColumnLayout = false;
  export const dispatch = createEventDispatcher();

  function onClick() {
    dispatch("selectItem");
  }
</script>

<style lang="scss">
  .nav-link-list {
    &--item {
      max-width: 192px;
      width: 50%;
    }

    &--view-all {
      margin-top: 24px;
    }

    &--two-column {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .nav-link-list--promo {
        margin-left: 48px;
      }
    }

    &--promo {
      width: 50%;
    }

    &--link {
      &:first-child {
        margin-top: 24px;
      }

      &:not(:last-child) {
        margin-bottom: 5px;
      }
    }

    &__hidden {
      display: none;
    }
  }
</style>

{#if navItem && navItem?.hidden === false}
  <div
    class={`nav-link-list ${navItem.hidden && "nav-link-list__hidden"} ${
      twoColumnLayout ? "nav-link-list--two-column" : ""
    }`}
  >
    <div class={`${twoColumnLayout && "nav-link-list--item"}`}>
      <div>
        {#if navItem.items}
          <Typography variant="button1" component="h3" theme="on-surface"
            >{navItem.title}</Typography
          >
        {:else}
          <!-- svelte-ignore a11y-no-static-element-interactions -->
          <div on:click={onClick} on:keydown={onClick}>
            <Link
              text={navItem.title}
              href={navItem.fullPath}
              underline={false}
              theme="on-surface"
              hoverTheme="on-surface-30"
            />
          </div>
        {/if}
      </div>

      <div class="nav-link-list--wrapper">
        {#if navItem.items}
          {#each navItem.items as childItem}
            {#if !childItem.hidden}
              <!-- svelte-ignore a11y-no-static-element-interactions -->
              <div
                class="nav-link-list--link"
                on:click={onClick}
                on:keydown={onClick}
              >
                <Link
                  text={childItem.title}
                  href={childItem.fullPath}
                  underline={false}
                  standard={true}
                  theme={childItem.highlighted ? "brand3" : "on-surface"}
                  hoverTheme="on-surface-30"
                />
              </div>
            {/if}
          {/each}
        {/if}
        {#if navItem.fullPath && navItem.items !== null}
          <!-- svelte-ignore a11y-no-static-element-interactions -->
          <div
            class="nav-link-list--link nav-link-list--view-all"
            on:click={onClick}
            on:keydown={onClick}
          >
            <Link
              text={$_("View All")}
              href={navItem.fullPath}
              underline={false}
              theme={navItem.highlighted ? "brand3" : "on-surface"}
              hoverTheme="on-surface-30"
            />
          </div>
        {/if}
      </div>
    </div>
    {#if navItem.promoimage && navItem.promoimage.image !== null}
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <div
        on:click={onClick}
        on:keydown={onClick}
        class={`${twoColumnLayout && "nav-link-list--promo"}`}
      >
        <NavPromoImage promoImage={navItem.promoimage} {twoColumnLayout} />
      </div>
    {/if}
  </div>
{/if}
